import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {
  Form,
  FormGroup,
  FormControl,
  FormCheck,
  FormLabel,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../../assets/images/logo.png";
import "./style.css";

const Signinmodal = ({ showModal, handleModalClose, openStep1Modal }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passError, setPassError] = useState("");

  const handleContinueClick = () => {
    let isValid = true;

  
    if (!email) {
      setEmailError("Email is required.");
      isValid = false;
    } else {
      setEmailError("");
    }

 
    if (!password) {
      setPassError("Password is required.");
      isValid = false;
    } else {
      setPassError("");
    }


    if (isValid) {
      alert("Signed in successfully!");
    }
  };

  return (
    <div>
      <Modal
        show={showModal}
        onHide={handleModalClose}
        dialogClassName="custom-modal-dialog"
      >
        <Modal.Header
          closeButton
          style={{
            background:
              "linear-gradient(to right, #fff6e9 0%,rgb(238, 217, 187) 200%)",
            padding: "10px",
          }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{ height: "12px", marginRight: "auto" }}
          />
        </Modal.Header>
        <Modal.Body>
          <Modal.Title
            className="h6 text-center w-100"
            style={{ color: "grey", fontSize: "18px" }}
          >
            Welcome back,
          </Modal.Title>
          <Modal.Title
            className="h6 text-center w-100"
            style={{ color: "grey", fontSize: "14px" }}
          >
            Connect to your account
          </Modal.Title>
          <Form>
            <FormGroup controlId="email" className="mt-3">
              <FormLabel style={{ marginLeft: "70px", fontSize: "16px" }}>
                Email
              </FormLabel>
              <FormControl
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-75 mx-auto"
              />
              {emailError && (
                <p
                  style={{ color: "red", fontSize: "12px", marginLeft: "60px" }}
                >
                  {emailError}
                </p>
              )}
            </FormGroup>
            <FormGroup controlId="password" className="mt-3">
              <FormLabel style={{ marginLeft: "70px", fontSize: "16px" }}>
                Password
              </FormLabel>
              <div
                style={{ position: "relative", width: "75%", margin: "0 auto" }}
              >
                <FormControl
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-100"
                />
                {passError && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginLeft: "60px",
                    }}
                  >
                    {passError}
                  </p>
                )}
                <a
                  href="/sign-in"
                  style={{
                    textDecoration: "underline",
                    color: "grey",
                    fontSize: "14px",
                    position: "absolute",
                    right: "0",
                    marginTop: "5px",
                  }}
                >
                  Forget your password ?
                </a>
              </div>
            </FormGroup>
            <Button
              variant="primary"
              onClick={handleContinueClick}
              style={{
                backgroundColor: "#FF6347",
                borderColor: "#FF6347",
                width: "75%",
                margin: "0 auto",
                display: "block",
                marginTop: "50px",
              }}
            >
              Login
            </Button>
          </Form>
          <div className="text-center" style={{ marginTop: "20px" }}>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleModalClose();
                openStep1Modal();
              }}
              style={{
                textDecoration: "underline",
                color: "grey",
                fontSize: "14px",
              }}
            >
              Not a member yet? Register now
            </a>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Signinmodal;
